import React from 'react';
import { useTranslation } from 'react-i18next';
import MoneyIcon from './MoneyIcon';

const DecorativeEmojis = () => {
  const { t } = useTranslation();
  return (
    <>
      <MoneyIcon className="icon-1" delay="0s">
        {t('referral.moneyBagEmoji')}
      </MoneyIcon>
      <MoneyIcon className="icon-2" delay="1s">
        {t('referral.dollarEmoji')}
      </MoneyIcon>
      <MoneyIcon className="icon-3" delay="2s">
        {t('referral.coinEmoji')}
      </MoneyIcon>
      <MoneyIcon className="icon-4" delay="0.5s">
        {t('referral.moneyWingsEmoji')}
      </MoneyIcon>
    </>
  );
};
export default DecorativeEmojis;
